// extracted by mini-css-extract-plugin
export default {"empty-cart-container":"EmptyCart_empty-cart-container__vPbfW","cart-logo":"EmptyCart_cart-logo__PXa7-","empty-cart-text":"EmptyCart_empty-cart-text__sxkNK"};